module.exports = __webpack_public_path__ + "static/logo-899f294fdfb67ae471fb55d3af2b66c8.png";